import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface TourCardProps {
  id?: number;
  name: string;
  service: string;
  price: number;
  imageUrl: string;
  className: string;
}

function formatPrice(price: number) {
  if (price >= 1_000_000) {
    return `${(price / 1_000_000).toFixed(2).replace('.00', '')}JT`;
  }
  if (price >= 100_000) {
    return `${Math.round(price / 1_000)}RB`;
  }
  return price.toLocaleString('id-ID');
}

function PromoCard({ id, name, service, price, imageUrl, className }: TourCardProps) {
  const { t } = useTranslation();
  const formattedPrice = useMemo(() => formatPrice(price || 0), [price]);

  return (
    <div
      className={`${className} sm:h-64 h-52 select-none drop-shadow-md overflow-hidden bg-cover rounded-lg rounded-tr-3xl cursor-pointer hover-shadow bg-center transition-all duration-300`}
      style={{ backgroundImage: `url(${imageUrl || '/assets/no-data-image.svg'})` }}
    >
      <div className="bg-gradient-to-t from-primary to-transparent h-full w-full text-white flex justify-end items-center flex-col hover:bg-black/50 transition-all duration-300">
        <div className="flex flex-col drop-shadow-lg items-center gap-4 px-2 py-2.5 sm:px-4 sm:py-5">
          <div className="flex flex-col items-center">
            <p className="sm:text-sm text-xs font-medium">{service}</p>
            <h1 className="font-semibold text-center text-xl sm:text-2xl capitalize">{name}</h1>
          </div>
          <div className="flex sm:gap-2 gap-1.5">
            <div className="flex flex-col items-end justify-start w-fit">
              <p className="sm:text-[6px] text-[6px] text-end font-medium">{t('general.startfrom')}</p>
              <p className="sm:text-sm text-xs font-semibold">IDR</p>
            </div>
            <div className="sm:text-4xl text-2xl text-currency font-semibold">
              <h1>{formattedPrice}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(PromoCard);
